<template>
  <div>
    <h5 class="measurement-title mb-0"> {{$t('dashboard_new_evollu.parameters.oximetry')}} </h5>
    <span class="measurement-timestamp"> {{$t('checkup_plus.reports.measurements.last_measurement_date', {date: moment(data.lastMeasurementTimestamp).format('DD/MM/YYYY HH:mm')})}} </span>

    <table class="w-100">
      <tr>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/oximetry.svg">
              <div>
                <h5 class="card-title">{{ $t('dashboard_new_evollu.measurement_types.oximetry_max_short') }}</h5>
              </div>
            </div>
            <span class="card-title">
              {{ oximetryMaxData.value }} {{oximetryMaxData.units}}
            </span>
            <br>
            <span class="card-description">
              <span style="font-weight: bold">{{ oximetryMaxData.previousValue }} {{ oximetryMaxData.units }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }}
            </span>
          </div>
        </td>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/oximetry.svg">
              <div>
                <h5 class="card-title">{{ $t('dashboard_new_evollu.measurement_types.oximetry_avg_short') }}</h5>
              </div>
            </div>
            <span class="card-title">
              {{ oximetryAvgData.value }} {{oximetryAvgData.units}}
            </span>
            <br>
            <span class="card-description">
              <span style="font-weight: bold">{{ oximetryAvgData.previousValue }} {{ oximetryAvgData.units }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }}
            </span>
          </div>
        </td>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/oximetry.svg">
              <div>
                <h5 class="card-title">{{ $t('dashboard_new_evollu.measurement_types.oximetry_min_short') }}</h5>
              </div>
            </div>
            <span class="card-title">
              {{ oximetryMinData.value }} {{oximetryMinData.units}}
            </span>
            <br>
            <span class="card-description">
              <span style="font-weight: bold">{{ oximetryMinData.previousValue }} {{ oximetryMinData.units }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }}
            </span>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/oximetry.svg">
              <div>
                <h5 class="card-title">{{ $t('dashboard_new_evollu.measurement_types.pulse_rate_max_short') }}</h5>
              </div>
            </div>
            <span class="card-title">
              {{ pulseRateMaxData.value }} {{pulseRateMaxData.units}}
            </span>
            <br>
            <span class="card-description">
              <span style="font-weight: bold">{{ pulseRateMaxData.previousValue }} {{ pulseRateMaxData.units }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }}
            </span>
          </div>
        </td>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/oximetry.svg">
              <div>
                <h5 class="card-title">{{ $t('dashboard_new_evollu.measurement_types.pulse_rate_avg_short') }}</h5>
              </div>
            </div>
            <span class="card-title">
              {{ pulseRateAvgData.value }} {{pulseRateAvgData.units}}
            </span>
            <br>
            <span class="card-description">
              <span style="font-weight: bold">{{ pulseRateAvgData.previousValue }} {{ pulseRateAvgData.units }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }}
            </span>
          </div>
        </td>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/oximetry.svg">
              <div>
                <h5 class="card-title">{{ $t('dashboard_new_evollu.measurement_types.pulse_rate_min_short') }}</h5>
              </div>
            </div>
            <span class="card-title">
              {{ pulseRateMinData.value }} {{pulseRateMinData.units}}
            </span>
            <br>
            <span class="card-description">
              <span style="font-weight: bold">{{ pulseRateMinData.previousValue }} {{ pulseRateMinData.units }}</span> {{ $t('checkup_plus.reports.patient_overall_summary.card.on_the_last_test') }}
            </span>
          </div>
        </td>
      </tr>
      <tr v-for="elem in data.results">
        <td colspan="3">
          <div class="measurement-card h-100 d-flex justify--space-between">
            <div class="title-container d-flex align-items-center">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/warning_yellow.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.result') }}</h5>
              </div>
            </div>
            <span :style="{ color: elem.resultColour }">
              {{ elem.resultName }}
            </span>
          </div>

          <div class="measurement-card h-100 mt-2">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/reference_values.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.measurement_reference_values', {measurement: $t('dashboard_new_evollu.parameters.oximetry')}) }}</h5>
              </div>
            </div>
            <div>
              <table>
                <tr v-for="elem in elem.referenceValues">
                  <td>
                    {{handleReferenceValuesCriterias(elem)}}
                  </td>
                  <td>
                    {{elem.resultMatchingCriteria}}
                  </td>
                </tr>
              </table>
            </div>
          </div>

          <div class="measurement-card h-100 mt-2">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/info_circle.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.patient_overall_summary.recommendation') }}</h5>
              </div>
            </div>
            <span class="card-text-normal">
              {{ elem.recommendations }}
            </span>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      oximetryMaxData: null,
      oximetryAvgData: null,
      oximetryMinData: null,
      pulseRateMaxData: null,
      pulseRateAvgData: null,
      pulseRateMinData: null,
    }
  },
  created() {
    this.data.measurementValues.forEach(elem => {
      if(elem.attributeCode === 'SPOMAX') {
        this.oximetryMaxData = elem
      } else if(elem.attributeCode === 'SPOAVG') {
        this.oximetryAvgData = elem
      }else if(elem.attributeCode === 'SPOMIN') {
        this.oximetryMinData = elem
      }else if(elem.attributeCode === 'PRMAX') {
        this.pulseRateMaxData = elem
      }else if(elem.attributeCode === 'PRAVG') {
        this.pulseRateAvgData = elem
      }else if(elem.attributeCode === 'PRMIN') {
        this.pulseRateMinData = elem
      }
    })

    //console.log(this.data)
  },
  methods: {
    handleReferenceValuesCriterias(elem) {
      var str = ""
      let index = 0
      let criteriasLength = elem.criteriaList.length
      if(elem.operator === "AND") {
        elem.criteriaList.forEach(elem => {
          str+= `${elem.attributeName} ${elem.criteria} `
          ++index
          if (index < criteriasLength) {
            str += "& "
          }

        })
      }
      return str
    }
  }
}
</script>

<style scoped lang="scss">
.measurement-card {
  padding: 20px;
  width: 100%;
  border: 1px solid lightgrey;
  border-radius: 15px;
  margin-bottom: 0;
}


table {
  width: 100%;
  height: 100%;
  table-layout: fixed;
}

td {
  height: 100%;
}

table td {
  padding-bottom: 10px;
}

table tr {
  margin-bottom: 10px;
}

table td:not(:first-child) {
  padding-left: 12px;
}

</style>
